import React from 'react';
import '../styles/Footer.css';
import { useTranslation } from 'react-i18next';
import { Container, Jumbotron } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TITLE, CONTACT_US, ADDRESS_1, ADDRESS_2, ADDRESS_3, PHONE, EMAIL } from '../data/navbar/menu';
import Logo from '../assets/images/logo.png';
import { faFacebookF, faInstagram, faLinkedinIn, faTwitter } from '@fortawesome/free-brands-svg-icons';


const Footer = () => {
  const {t} = useTranslation();
  return(
    <Jumbotron fluid style={{ backgroundColor: 'black', color: 'white', marginBottom: 0}}>
      <Container>
        <div class="footer">
          <div class="footer-company-details">
            <div class="company-heading">
              <img
                src={Logo}
                width={50}
                alt={"Freshokartz"}
              />
              <h2> {t(TITLE)} </h2>
            </div>

            <div class="social-links">
              <a class="social-link" rel="noreferrer" target="_blank" href="https://twitter.com/freshokartz">
                <FontAwesomeIcon icon={faTwitter} color="white" size='sm'/>
              </a>
              <a class="social-link" rel="noreferrer" target="_blank" href="https://facebook.com/freshokartz" >
                  <FontAwesomeIcon icon={faFacebookF} color="white" size='sm'/>
              </a>
              <a class="social-link" rel="noreferrer" target="_blank" href="https://www.instagram.com/freshokartz/">
                  <FontAwesomeIcon icon={faInstagram} color="white" size='sm'/>
              </a>
              <a class="social-link" rel="noreferrer" target="_blank" href="https://www.linkedin.com/company/freshokartz">
                  <FontAwesomeIcon icon={faLinkedinIn } color="white" size='sm'/>
              </a>
            </div>
          </div>
          
          <div class="company-contatct">
            <h4> {t(CONTACT_US)} </h4>
            <hr/>
            <p> {t(ADDRESS_1)} </p>
            <p> {t(ADDRESS_2)} </p>
            <p> {t(ADDRESS_3)} </p>
            <p> <strong>{t(PHONE)}</strong> +91 9610776707</p>
            <p> <strong>{t(EMAIL)}</strong> info@freshokartz.com</p>
          </div>
        </div>

        <div class="copyright">
          <p> © Copyright Freshokartz. All Rights Reserved </p>
        </div>
      </Container>
      </Jumbotron>
  );
}

export default Footer;
